var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.33,
    height: 15.616,
    viewBox: "0 0 14.33 15.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8233",
    "data-name": "Path 8233",
    d: "M8.947,16H4.527V8.224H15.214v2.3a.764.764,0,0,0,1.305.552h0a.778.778,0,0,0,.221-.552V5.112a1.546,1.546,0,0,0-1.527-1.556H14.45V2.778A.773.773,0,0,0,13.687,2h0a.773.773,0,0,0-.763.778v.778H6.817V2.778A.773.773,0,0,0,6.053,2h0a.773.773,0,0,0-.763.778v.778H4.527A1.535,1.535,0,0,0,3.008,5.112L3,16a1.541,1.541,0,0,0,1.527,1.556h4.42a.782.782,0,0,0,.542-1.33h0A.781.781,0,0,0,8.947,16Zm2.229-1.354a.75.75,0,0,1,1.076,0l1.076,1.1,2.7-2.754a.75.75,0,0,1,1.076,0,.785.785,0,0,1,0,1.1l-3.237,3.3a.75.75,0,0,1-1.076,0l-1.618-1.649A.776.776,0,0,1,11.176,14.65ZM9.328,13.117a.75.75,0,0,1-1.076,0l-.672-.685-.672.685a.75.75,0,0,1-1.076,0,.785.785,0,0,1,0-1.1l.672-.685-.672-.685a.785.785,0,0,1,0-1.1.75.75,0,0,1,1.076,0l.672.685.672-.685a.75.75,0,0,1,1.076,0,.785.785,0,0,1,0,1.1l-.672.685.672.685A.785.785,0,0,1,9.328,13.117Z",
    transform: "translate(-3 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayOff);
export default __webpack_public_path__ + "static/media/day_off.5aa561eb8e5b3a0fcfd7f34dd6bc5412.svg";
export { ForwardRef as ReactComponent };